import styles from "~/styles/burn-rate.module.css";

interface Ring {
  label: string;
  value: number;
  max: number;
  unit?: string;
  color?: string;
}

interface MetricRingsProps {
  rings: Ring[];
}

function RingSVG({ value, max, color = "#FFFFFF" }: { value: number; max: number; color?: string }) {
  const size = 72;
  const stroke = 5;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.min(Math.max(value / max, 0), 1);
  const dash = pct * c;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className={styles.ringSvg}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${dash} ${c - dash}`}
        strokeDashoffset={-c * 0.25}
        style={{ transition: "stroke-dasharray 0.6s ease" }}
      />
    </svg>
  );
}

export function MetricRings({ rings }: MetricRingsProps) {
  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Métricas</p>
      <div className={styles.ringsGrid}>
        {rings.map((ring, i) => (
          <div key={i} className={styles.ringItem}>
            <RingSVG value={ring.value} max={ring.max} color={ring.color} />
            <div className={styles.ringText}>
              <span className={styles.ringValue}>
                {ring.value.toFixed(0)}{ring.unit ? <span className={styles.ringUnit}>{ring.unit}</span> : ""}
              </span>
              <span className={styles.ringLabel}>{ring.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
